import Text from "@ingka/text";
import React from "react";

type Props = {
  heading: string;
  subHeading?: string;
  text: string;
  textSize?: "l" | "m" | "s" | "xl";
} & React.HtmlHTMLAttributes<HTMLDivElement>;

const TextSection = ({
  heading,
  subHeading,
  text,
  textSize = "s",
  className,
  ...rest
}: Props) => {
  return (
    <div className={className} {...rest}>
      <Text tagName="h2" headingSize="m" className="mb-space100 text-lg">
        {heading}
      </Text>
      {subHeading && <Text bodySize="m">{subHeading}</Text>}
      <Text tagName="p" bodySize={textSize}>
        {text}
      </Text>
    </div>
  );
};

export default TextSection;
